export const queryKeys = {
  PREPAYMENT: 'PREPAYMENT',
  ADDITIONAL_PAYMENT: 'ADDITIONAL_PAYMENT',
  CURRENCY_SOFT: 'CURRENCY_SOFT' 
};
